import { OpenAdvanceRow, SalesJournalResponse } from 'types/reports';
import { objectToQueryParams } from 'utils/linkUtil';
import { portalAPI } from './portalAPI';

const APIReportsSlice = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        getOpenAdvances: builder.query<OpenAdvanceRow[], { asOfDate: string }>({
            query: ({ asOfDate }) => `/v1/reports/open-advances${objectToQueryParams({ asOfDate })}`,
        }),
        getSalesJournal: builder.query<
            SalesJournalResponse,
            { periodStartDate: string; periodEndDate: string; includePrepayments?: boolean }
        >({
            query: (params) => `/v1/reports/sales-journal${objectToQueryParams(params)}`,
        }),
    }),
    overrideExisting: false,
});

export const { useLazyGetOpenAdvancesQuery, useLazyGetSalesJournalQuery } = APIReportsSlice;
